<template>
    <el-row>
        <el-table
                show-summary
                :summary-method="totalSumMethod"
                :data="groupCraftRecord.sizegroupcraftrecord_set">

            <el-table-column width="140" prop="shop_id" label="尺码"/>
            <el-table-column :width="isMdfStatue ?'150' : '80'" align="center" prop="plan_num">
                <template slot="header" slot-scope="scope">
                    <span style="margin-right: 4px">分配数量</span>
                    <el-tag size="mini" v-if="planNumChanged">**</el-tag>
                </template>

                <template slot-scope="scope">
                    <el-input-number
                            @change="initChangeFields"
                            v-if="isMdfStatue"
                            size="mini"
                            :min="0"
                            :max="scope.row.sumPlan"
                            :step="1"
                            v-model="scope.row._plan_num">
                    </el-input-number>

                    <span v-else>{{ scope.row.plan_num }}</span>
                </template>
            </el-table-column>
            <el-table-column width="95" prop="finish_num" label="已上报数量">
                <template slot-scope="scope">
                    <span style="margin-right: 5px">{{ scope.row.finish_num }}</span>
                    <el-tooltip v-if="scope.row.finish_num + scope.row.scrap_num !== scope.row.plan_num"  effect="dark" content="上报数量+报次数量 必须等于 分配数量" placement="top-start">
                        <i class="el-icon-question text-danger"></i>
                    </el-tooltip>

                </template>
            </el-table-column>
            <template v-for="(batchGroupCraft,index) in groupCraftRecord.batchgroupcraftfinish_set">
                <el-table-column :key="index">
                    <template slot="header" slot-scope="scope">
                        <el-popover
                                placement="top-start"
                                width="200"
                                trigger="hover"
                                :content="batchGroupCraft.created">
                            <el-button
                                    @click="showBatchDetail('批次'+(index+1),batchGroupCraft)"
                                    slot="reference"
                                    size="mini">批次{{index+1 }}
                            </el-button>
                        </el-popover>

                    </template>

                    <template slot-scope="scope">
                        <span>{{ getBatchFinishNum(batchGroupCraft,scope.row) }}</span>
                    </template>
                </el-table-column>
            </template>

            <el-table-column align="center" prop="scrap_num" label="报次数量">
                <template slot="header" slot-scope="scope">
                    <span style="margin-right: 4px">报次数量</span>
                    <el-tag size="mini" v-if="scrapNumChanged">**</el-tag>
                </template>
                <template slot-scope="scope">
                    <el-input-number
                            @change="initChangeFields"
                            v-if="isVerify && !groupCraftRecord.finish"
                            size="mini"
                            :step="1"
                            :min="0"
                            :max="scope.row.sumPlan"
                            v-model="scope.row._scrap_num">
                    </el-input-number>
                    <span v-else>{{ scope.row.scrap_num }}</span>
                </template>
            </el-table-column>
            <el-table-column :width="isMdfStatue ?'150' : '70'" align="center" label="工价">
                <template slot="header" slot-scope="scope">
                    <span style="margin-right: 4px">工价</span>
                    <el-tag size="mini" v-if="priceChanged">**</el-tag>
                </template>
                <template slot-scope="scope">
                    <el-input-number
                            @change="initChangeFields"
                            v-if="isMdfStatue"
                            size="mini"
                            :step="0.01"
                            :min="0"
                            v-model="scope.row._price">
                    </el-input-number>
                    <span v-else>{{ scope.row.price }}</span>
                </template>
            </el-table-column>
        </el-table>
    </el-row>
</template>

<script>
    import {mapGetters, mapMutations} from 'vuex'

    export default {
        name: "GroupCraftTable",
        props: {
            groupCraftRecord: {
                type: Object,
                required: true,
            },
        },
        data() {
            return {
                planNumChanged: false,
                priceChanged: false,
                scrapNumChanged: false,
            }
        },
        computed: {
            ...mapGetters({
                isMdfStatue: 'currentCraftIsMdf',
                isVerify: 'currentCraftIsVerify',
            })
        },
        methods: {
            /**
             * 初始化改变的字段
             * 当更新属性值后，应该检查是否需要提醒 `字段改变`
             */
            initChangeFields() {
                const changeFieldMap = new Map([
                    ['plan_num', 'planNumChanged'],
                    ['price', 'priceChanged'],
                    ['scrap_num', 'scrapNumChanged']
                ])

                changeFieldMap.forEach((value, field) => {
                    this[value] = this.checkFieldChanged(field)
                })

            },

            /**
             * 检查 groupCraftRecord.sizegroupcraftrecord_set 中指定属性是否发生了变化
             * 该属性的临时名称为 _<field>
             * 例如传入 price 则会遍历 sizegroupcraftrecord_set ，检查 _price 与 price 是否相等
             *
             * @param field {String} 属性名称
             * @return {Boolean} 属性是否发生了变化
             */
            checkFieldChanged(field) {
                for (let i = 0; i < this.groupCraftRecord.sizegroupcraftrecord_set.length; i++) {
                    const tempField = '_' + field
                    const sizeGroupCraftRecord = this.groupCraftRecord.sizegroupcraftrecord_set[i]

                    if (sizeGroupCraftRecord[field] !== sizeGroupCraftRecord[tempField]) {
                        return true
                    }
                }
                return false

            },
            getBatchFinishNum(BatchGroupCraft, sizeGroupCraftRecord) {
                for (let i = 0; i < BatchGroupCraft.sizebatchgroupcraft_set.length; i++) {
                    const sizeBatchGroup = BatchGroupCraft.sizebatchgroupcraft_set[i]
                    if (sizeBatchGroup.size_group_craft_record === sizeGroupCraftRecord.id) {
                        return sizeBatchGroup.finish_num
                    }
                }
                return 0
            },
            showBatchDetail(title, batchGroupCraft) {
                this.setGroupBatchDetailTitle(title)
                this.setGroupBatchDetailShow(true)
                this.setCurrentGroupBatch(batchGroupCraft)
            },
            totalSumMethod({columns, data}) {
                const sum = this.$defaultTableSummary({columns, data})
                // 前三个不变
                for (let i = 0; i < this.groupCraftRecord.batchgroupcraftfinish_set.length; i++) {
                    const batchGroupCraft = this.groupCraftRecord.batchgroupcraftfinish_set[i]
                    sum[3 + i] = batchGroupCraft.finish_num
                }

                sum[columns.length - 1] = '/'
                return sum
            },
            ...mapMutations(['setGroupBatchDetailTitle', 'setGroupBatchDetailShow', 'setCurrentGroupBatch'])
        },
        updated() {
            this.initChangeFields()
        },
    }
</script>

<style scoped>

</style>